namespace Solovis.UI {

    // ProgressControl is a control used to indicate the status of an asynchronous operation.
    /*
     * Options:
     * width
     * height
     * max
     * value 
     * label (requires value and max)
     * {
     *      format:
     *            Parameters:
     *              %v - value
     *              %m - max
     *              %r - remaining
     *              %p - percentage (will display the '%')
     *            
     *      alignment:  "left" "right" or "center"
     * }
     */
    export class ProgressControl extends Solovis.UI.BaseControl {

        public _width;
        public _height;
        public _max;
        public _value;
        public _label;
        public _state;

        public progress;
        public _labelDisplay;

        constructor(options) {
            super(options);

            var self = this;

            if ((Solovis.isNotNull(options.value) && Solovis.isNull(options.max)) ||
                ((Solovis.isNotNull(options.max) && Solovis.isNull(options.value)))) {
                throw "Both max and value are required for a determinate progress bar.";
            }
            this._width = options.width ? options.width : null;
            this._height = options.height ? options.height : null;
            this._max = options.max ? options.max : null;
            this._value = options.value ? options.value : null;
            this._label = options.label ? options.label : null;
            this._state = this._value ? "determinate" : "indeterminate";
        }


        public doRender() {
            var self = this;

            if (this._state == "determinate") {
                this.progress = $("<progress>")
                    .appendTo(this.container);
                if (this._width) {
                    this.progress.css("width", this._width);
                }
                if (this._height) {
                    this.progress.css("height", this._height);
                }
                if (this._max) {
                    this.progress.attr("max", this._max);
                }
                if (this._value) {
                    this.progress.attr("value", this._value);
                }

                if (this._label) {
                    this._labelDisplay = $("<span>")
                        .addClass("progress-label")
                        .text(this._formatLabel())
                        .appendTo(this.container);
                    if (this._width) {
                        this._labelDisplay.css("width", this._width);
                    }
                    if (this._height) {
                        this._labelDisplay.css("line-height", this._height);
                    }
                    if (this._label.alignment) {
                        this._labelDisplay.css("text-align", this._label.alignment);
                    }
                }
                this.progress.appendTo(this.container);
            }
            else {
                this.progress = $("<div>")
                    .addClass("progress-indeterminate")
                    .appendTo(this.container);

                this.progress.append(
                    $("<div>")
                        .addClass("waitingbar waitingblock_1"))
                    .append(
                    $("<div>")
                        .addClass("waitingbar waitingblock_2"))
                    .append(
                    $("<div>")
                        .addClass("waitingbar waitingblock_3"))
                    .append(
                    $("<div>")
                        .addClass("waitingbar waitingblock_4"))
                    .append(
                    $("<div>")
                        .addClass("waitingbar waitingblock_5"));
            }

        }

        public _formatLabel() {
            return this._label.format
                .replace("%v", this._value)
                .replace("%m", this._max)
                .replace("%r", this._max - this._value)
                .replace("%p", this._calculatePercentage() + "%");
        }

        public formatLabel(formatString) {
            var lblText = formatString
                .replace("%v", this._value)
                .replace("%m", this._max)
                .replace("%r", this._max - this._value)
                .replace("%p", this._calculatePercentage() + "%");
            this._labelDisplay.text(lblText);
        }

        public _calculatePercentage() {
            var percent = Math.ceil(this._value / this._max * 100);
            if (percent > 100) {
                console.log("percent > 100");
                percent = 100;
            }
            return percent;
        }

        public value(value?) {
            if (Solovis.isNotNull(value)) {
                if (value > this._max) {
                    value = this._max;
                }
                this._value = value;
                this.progress.attr("value", value);
                if (this._label && this._label.type === "step") {
                    this._labelDisplay.text(this._formatLabel());
                }
            }
            return this._value;
        }

        public max(max?) {
            if (Solovis.isNotNull(max)) {
                if (max < this._value) {
                    max = this._value;
                }
                this._max = max;
                this.progress.attr("max", max);
                if (this._label && this._label.type === "step") {
                    this._labelDisplay.text(this._formatLabel());
                }
            }
            return this._max;
        }

        public height(height?) {
            if (Solovis.isNotNull(height)) {
                this._height = height;
                this.progress.css("height", this._height);
                this._labelDisplay.css("line-height", this._height);
            }
            return this._height;
        }

        public width(width?) {
            if (Solovis.isNotNull(width)) {
                this._width = width;
                this.progress.css("width", this._width);
                this._labelDisplay.css("width", this._width);
            }
            return this._width;
        }

        public stepForward() {
            if (this._label.type === "step" && this._value < this._max) {
                this._value++;
                this._labelDisplay.text(this._formatLabel());
                this.progress.attr("value", this._value);
            }
        }

        public stepBackward() {
            if (this._label.type === "step" && this._value > 0) {
                this._value--;
                this._labelDisplay.text(this._formatLabel());
                this.progress.attr("value", this._value);
            }
        }
    }

}
